import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetCreditHistory = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_REPLENISHMENT_HISTORY
            });

            if (data.status === 'success') {
                const list = [...getState().creditMobile.history.list];

                list.push(data.list);
                dispatch(Action.SetGetCreditHistoryAction({
                    list: list.flat(1),
                    page: data.countPage
                }));
                dispatch(Action.SetLoadingAction(false))
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetCreditHistory as SetGetCreditHistory
}